import {ref, computed, watch} from 'vue';
import axiosClient from '../../modules/axiosClient';

type Models = {
    [key: string]: string,
}

export default function useCarWorthForm(usedCarMakes: DropdownOptions, newCarMakes: DropdownOptions, van = false, newDriver = false) {
    const condition = ref( 'used');
    const make = ref('');
    const model = ref('');
    const carModels = ref({} as Models);
    const loading = ref(false );

    const vehicleConditions = computed((): DropdownOptions => {
        return [
            {value: 'used', text: 'Used'},
            {value: 'new', text: 'New'},
        ];
    });

    const vehicleMakes = computed((): DropdownOptions => {
        if (condition.value === 'used') {
            return usedCarMakes;
        }

        return newCarMakes;
    });

    const vehicleModels = computed((): DropdownOptions => {
        const dropdown: DropdownOptions = [];
        Object.keys(carModels.value).forEach((key) => {
            const model = carModels.value[key];
            dropdown.push({value: key.toLowerCase().replace(' ', '-'), text: model});
        });
        return dropdown;
    });

    const makeModelSearchUrl = computed((): string => {
        if (model.value.length) {
            return '/' + condition.value + '-cars/' + make.value + '_' + model.value;
        } else if (make.value.length) {
            return '/' + condition.value + '-cars/' + make.value;
        }
        return 'javascript:void(0)';
    });

    const getModels = () => {
        if (make.value === '') {
            return;
        }

        let getModelsUrl = '/api/car-search/models/' + condition.value + '/' + make.value;

        if (van) {
            getModelsUrl = getModelsUrl + '/van';
        }
        if (newDriver) {
            getModelsUrl = getModelsUrl + '?newdriver';
        }
        loading.value = true;
        axiosClient.get(getModelsUrl).then((response) => {
            carModels.value = response.data;
            loading.value = false;
        });
    };

    const goToMakeModelPage = () => {
        window.location.href = makeModelSearchUrl.value;
    };

    const goToVanMakeModelPage = () => {
        window.location.href = makeModelSearchUrl.value + '/bodystyle-van_independent-1';
    };

    const goToNewDriverModelPage = () => {
        window.location.href = makeModelSearchUrl.value + '/pricetype-cash_maxinsurance-5';
    };

    watch(condition, () => {
        make.value = '';
    });

    watch(make, () => {
        model.value = '';
        carModels.value = {};
        getModels();
    });

    return {
        condition,
        make,
        model,
        loading,
        vehicleConditions,
        vehicleMakes,
        vehicleModels,
        goToMakeModelPage,
        goToVanMakeModelPage,
        goToNewDriverModelPage,
        makeModelSearchUrl,
    };
}
